export default __webpack_public_path__ + "static/media/pokemon_go_icon.7bf9de73.png";